import { Box, Button, IconButton, Popover, Typography } from "@mui/material";
import clsx from "clsx";
import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@lang/index';
import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { LandingComponentStyle } from "@styles/auth/LandingComponentStyle";

import { ReactComponent as ClockIcon } from "@common/images/ClockIcon.svg";
import { ReactComponent as KeywordIcon } from "@common/images/KeywordIcon.svg";
import { ReactComponent as LanguageIcon } from "@common/images/LanguageSelectWhite.svg";
import { ReactComponent as LogoWithTile } from "@common/images/logo_aigle.svg";
import { ReactComponent as PersonIcon } from "@common/images/PersonIcon.svg";

import ChungCheong from "@common/images/c_logo1.png";

import { observer } from "mobx-react";
import useNaviCustom from "@hooks/useNaviCustom";
import { useStores } from "@hooks/useStores";
import { AigleVersion } from "../../../AigleVersion";
import DownArrowThick from "@common/images/DownArrowThick.png";
import { InquiryDialog } from "@components/common";
import { useNeoConfirm } from "@hooks/useNeoConfirm";

type Props = {
}


function LandingComponent(props: Props) {
	const classes = useEmotionStyles( LandingComponentStyle );
	/*
	const cardList = [
		{ title: i18n.t(''), content: i18n.t('AI 환류 기반 평가의 객관도와 신뢰도 향상 '), icon: <ClockIcon /> },
		{ title: i18n.t(''), content: i18n.t('AI기술을 통해 학생 개개인에 맞춘 교육이 가능해집니다.'), icon: <PersonIcon /> },
		{ title: i18n.t(''), content: i18n.t('데이터 분석을 기반으로 효과적인 교육전략을 세울 수 있습니다.'), icon: <KeywordIcon /> },
	]
	*/

	// const navigate = useNavigate();
	// const location = useLocation();
	// const { navigate, location } = props;
	const { navigateStore } = useStores();;
	const naviCustom = useNaviCustom();
	const {alert, confirm} = useNeoConfirm();

	const handleClickStart = () => {
		naviCustom.go(`/login`);
		// props.navigate(`/login`);
	}

	const handleClickDownload = () => {
		naviCustom.go(`/download`);
		// props.navigate(`/login`);
	}

	const i18next = useTranslation();


	const languages = [
		{ code: 'ko', name: '한국어' },
		{ code: 'ja', name: '日本語' },
		{ code: 'en', name: 'English' }
	];


	const [anchorLangEl, setAnchorLangEl] = React.useState(null);
	const handleLangClick = (event) => { setAnchorLangEl(event.currentTarget); };
	const handleLangClose = () => { setAnchorLangEl(null); };
	const openLang = Boolean(anchorLangEl);
	const [lang, setLang] = React.useState(navigateStore.language);
	const handleLanguageSelect = (code) => {
		navigateStore.changeLanguage(code);
		setLang(code);
		handleLangClose();
	}

	const [openInquiryDialog, setOpenInquiryDialog] = React.useState(false);
	const handleOpenInquiryDialog = () => setOpenInquiryDialog(true);
	const handleCloseInquiryDialog = () => setOpenInquiryDialog(false);
	const handleFinishInquiryDialog = () => {
        alert("문의가 접수되었습니다.");
	};


	const Card = ({ title, highlightText, arrowText }) => {
		return (
		  <div className="card">
			<p className="card-title">{title}</p>
			<p className="card-highlight">{highlightText}</p>
			<div className="card-arrow">↓</div>
			<p className="card-result">{arrowText}</p>
		  </div>
		);
	  };

	const id = openLang ? 'simple-popover' : undefined;
	return (
		<Box className={classes.container}>
			<Box className={classes.topbar}>
				<LogoWithTile className={classes.logo} />
				<Box style={{ position: "absolute", bottom: 0, left: 160, width: 200, textAlign: "left", padding: 16 }}>
				<img style={{ width: 200, display: "block" }} src={ChungCheong} alt="ChungCheong" />
			</Box>
				<Box>
					<IconButton
						className={clsx(classes.iconBtnReset, classes.langButtonStyle)}
						onClick={handleLangClick}
						sx={{ marginRight: "20px" }}
						disableRipple

					>
						<LanguageIcon />
					</IconButton>
					<Popover id={id}
						open={openLang}
						anchorEl={anchorLangEl}
						onClose={handleLangClose}
						anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
						className={classes.LanguageBox}>
						<Box className={classes.LanguageBoxInner}>
							{/* <Typography className={classes.languageTitle}>{i18next.t("언어 선택")}</Typography> */}
							{languages.map((language) => (
								<Button
									key={language.code}
									className={`${classes.LanguageButton} ${lang === language.code ? classes.SelectedLanguage : ''}`}
									onClick={() => handleLanguageSelect(language.code)}
									disableRipple
								>
									<Typography>{language.name}</Typography>
								</Button>
							))}
						</Box>
					</Popover>

					<Button className={classes.buttonStyle} onClick={handleOpenInquiryDialog} sx={{ marginRight: "10px" }}>
						{i18next.t("문의하기")}
					</Button>

					<Button className={classes.buttonStyle} onClick={handleClickDownload} sx={{ marginRight: "10px" }}>
						{i18next.t("선생님 필수 기능 다운로드")}
					</Button>


					<Button className={classes.buttonStyle} onClick={handleClickStart}>
						{i18next.t("로그인")}
					</Button>
				</Box>
			</Box>
			<Box className={classes.lendingWrap}>
				<Box className={classes.info}>
					<Typography className={classes.slogan}>
						{/*
						<b>{i18next.t("AI기술")}</b>{i18next.t("을 활용한")} <br /> <b>{i18next.t("미래의 교육")}</b>{i18next.t("을 위한 AIGLE")}<br />*/}
						디지털 교육혁신을 선도하는 <b>충남미래교육!</b> <br/> 서·논술형 평가 준비부터 환류까지, AIGLE과 함께합니다.
					</Typography>
					
				</Box>

				<Box className={classes.boxStyle}>
				<Box className={classes.card}>
				<div>
					<p className={classes.cardTitle}>{'AI 환류 기반 평가의'}</p>
					<p className={classes.cardTitle} style={{ color: '#233fdc'}}>{'객관도와 신뢰도 향상'}</p>
					<img style={{ width: 40, display: "block",margin: '0 auto' }} src={DownArrowThick} alt="DownArrowThick" />
					<p className={classes.cardResult}>{'사교육비 경감 기여'}</p>
				</div>
				</Box>

				<Box className={classes.card}>
				<div>
					<p className={classes.cardTitle}>{'서·논술형 평가에 대한'}</p>
					<p className={classes.cardTitle} style={{ color: '#233fdc'}}>{'정교한 환류 제공'}</p>
					<img style={{ width: 40, display: "block",margin: '0 auto' }} src={DownArrowThick} alt="DownArrowThick" />
					<p className={classes.cardResult}>{'학생 맞춤형 학습 지원'}</p>
				</div>
				</Box>

				<Box className={classes.card}>
				<div>
					<p className={classes.cardTitle}>{'교사의'} <span className={classes.cardTitle} style={{ color: '#233fdc'}}>{'평가 업무'}</span></p>
					<p className={classes.cardTitle} style={{ color: '#233fdc'}}>{'자동화 및 간소화'}</p>
					<img style={{ width: 40, display: "block",margin: '0 auto'  }} src={DownArrowThick} alt="DownArrowThick" />
					<p className={classes.cardResult}>{'업무 부담 경감 및'}</p>
					<p className={classes.cardResult}>{'교육활동 몰입 지원'}</p>
				</div>
                </Box>
				</Box>
				
			</Box>
			<Box sx={{ textAlign: "right", marginRight: '10px' }}>
				{
					// version
				}
				<Typography>
					{new AigleVersion().version}
				</Typography>
			</Box>
			<InquiryDialog open={openInquiryDialog} onClose={handleCloseInquiryDialog} onFinish={handleFinishInquiryDialog} />
		</Box>
	);
}

export default observer<typeof LandingComponent>(LandingComponent);
